<div class="row-wrapper">
  <div class="row-title-wrapper" (click)="toggleRow()">
    @if (!!titleIconName) {
      <rkt-icon [name]="titleIconName" class="row-title-icon" [class.is-expanded]="!isCollapsed"></rkt-icon>
    }
    @if (!!title) {
      <div class="row-title">{{ title }}</div>
    }
    <rkt-icon class="row-toggler" [class.is-expanded]="!isCollapsed" [name]="isCollapsed ? 'chevron-down' : 'chevron-up'"></rkt-icon>
  </div>
  @if (!isCollapsed) {
    <div class="row-content">
      <ng-content></ng-content>
    </div>
  }
</div>
